/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Desktop_TitleInputs */

const en_pc_online_desktop_title = /** @type {(inputs: Pc_Online_Desktop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working with big files every day?`)
};

const zh_pc_online_desktop_title = /** @type {(inputs: Pc_Online_Desktop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每天都要处理大文件？`)
};

/**
* | output |
* | --- |
* | "Working with big files every day?" |
*
* @param {Pc_Online_Desktop_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_desktop_title = /** @type {((inputs?: Pc_Online_Desktop_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Desktop_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_desktop_title(inputs)
	return zh_pc_online_desktop_title(inputs)
});
export { pc_online_desktop_title as "pc.online.desktop_title" }